<template>
  <div class="home_Index">
    <div v-if="!isPlatformSide" class="home-stats-grid">
      <div v-for="(item,index) of numberList" :key="index">
        <div class="content_item" :class="'content_item--' + (index % 5)" style="cursor:pointer">
          <div class="container_flex">
            <p class="left item-name">{{item.name}}</p>
            <p class="right ri_label">{{item.type || '统计'}}</p>
          </div>
          <hr class="item-divider">
          <div class="item-num-wrap">
            <p v-if="item.key === 'totalUnverifyPrincipal'" class="top-hint">充值本金</p>
            <p class="left item-num">{{displayStatValue(item.num)}}</p>
          </div>
          <div v-if="item.subLabel" class="item-foot">
            <template v-if="item.key === 'totalUnverifyPrincipal'">
              <p class="top-hint">充值赠送</p>
              <p class="sub-num">{{displayStatValue(item.subNum)}}<i v-if="item.icon" :class="item.icon"></i></p>
            </template>
            <template v-else>
              <div class="container_flex">
                <p class="left yesterday">{{item.subLabel}}</p>
                <p class="right yesterday">{{displayStatValue(item.subNum)}}<i v-if="item.icon" :class="item.icon"></i></p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isPlatformSide" class="dashboard-grid">
      <div class="dashboard-card dashboard-card--half">
        <div class="card-header">
          <div class="card-title">热门项目 TOP10（人数）</div>
          <div class="card-tabs">
            <span class="card-tab" :class="{ 'card-tab--active': projectRankingCountRangeType === 'today' }" @click="switchProjectRankingCountRange('today')">今日</span>
            <span class="card-tab" :class="{ 'card-tab--active': projectRankingCountRangeType === 'month' }" @click="switchProjectRankingCountRange('month')">本月</span>
            <span class="card-tab" :class="{ 'card-tab--active': projectRankingCountRangeType === 'total' }" @click="switchProjectRankingCountRange('total')">累计</span>
          </div>
        </div>
        <div ref="hotProjectChart" class="chart-box chart-box--ranking"></div>
      </div>
      <div class="dashboard-card dashboard-card--half">
        <div class="card-header">
          <div class="card-title">热门项目 TOP10（金额）</div>
          <div class="card-tabs">
            <span class="card-tab" :class="{ 'card-tab--active': projectRankingAmountRangeType === 'today' }" @click="switchProjectRankingAmountRange('today')">今日</span>
            <span class="card-tab" :class="{ 'card-tab--active': projectRankingAmountRangeType === 'month' }" @click="switchProjectRankingAmountRange('month')">本月</span>
            <span class="card-tab" :class="{ 'card-tab--active': projectRankingAmountRangeType === 'total' }" @click="switchProjectRankingAmountRange('total')">累计</span>
          </div>
        </div>
        <div ref="hotProjectChartCopy" class="chart-box chart-box--ranking"></div>
      </div>
      <div class="dashboard-card">
        <div class="card-header">
          <div class="card-title">客户来源</div>
          <div class="card-tabs">
            <span class="card-tab" :class="{ 'card-tab--active': customerSourceRangeType === 'today' }" @click="switchCustomerSourceRange('today')">今日</span>
            <span class="card-tab" :class="{ 'card-tab--active': customerSourceRangeType === 'month' }" @click="switchCustomerSourceRange('month')">本月</span>
          </div>
        </div>
        <div ref="customerSourceChart" class="chart-box"></div>
      </div>
      <div class="dashboard-card">
        <div class="card-header">
          <div class="card-title">时段客流</div>
        </div>
        <div ref="periodFlowChart" class="chart-box"></div>
      </div>
      <div class="dashboard-card">
        <div class="card-header">
          <div class="card-title">票种占比</div>
          <div class="card-tabs">
            <span class="card-tab" :class="{ 'card-tab--active': ticketShareRangeType === 'today' }" @click="switchTicketShareRange('today')">今日</span>
            <span class="card-tab" :class="{ 'card-tab--active': ticketShareRangeType === 'month' }" @click="switchTicketShareRange('month')">本月</span>
          </div>
        </div>
        <div ref="ticketShareChart" class="chart-box"></div>
      </div>
    </div>
  </div>
</template>
<script>
import MyAuditDialog from '@/components/Custom/MyAuditDialog'
import * as echarts from 'echarts'
export default {
  name: 'defaultPage',
    components: {
        MyAuditDialog
    },
  props: {},
  data () {
    let nowDate = new Date()
    let year = nowDate.getFullYear()
    let month = nowDate.getMonth() + 1 > 9 ? (nowDate.getMonth() + 1): '0' + (nowDate.getMonth() + 1)
    let day = nowDate.getDate() > 9 ? nowDate.getDate() : '0' + nowDate.getDate()
    var newDay = year + '-' + month + '-'+ day
    let nowDate2 = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
    let year2 = nowDate2.getFullYear()
    let mother2 = nowDate2.getMonth() > 8 ? (nowDate2.getMonth() + 1) : ('0' + (nowDate2.getMonth() + 1))
    let day2 = nowDate2.getDate() > 9 ? (nowDate2.getDate()) : ('0' + nowDate2.getDate())
    let nowDay2 = year2 + '-' + mother2 + '-' + day2
    return {
      myPendingLoading:true,
      numberList:[
        { key: 'todayCustomer', name:'今日客户', num:'', subLabel:'', subNum:'', type:'今日', icon:'' },
        { key: 'todayStoreIncome', name:'今日门店收入（现金）', num:'', subLabel:'', subNum:'', type:'今日', icon:'' },
        { key: 'todayRechargeGift', name:'今日充值赠送', num:'', subLabel:'', subNum:'', type:'今日', icon:'' },
        { key: 'todayStoreVerify', name:'今日门店核销', num:'', subLabel:'', subNum:'', type:'今日', icon:'' },
        { key: 'todayOnlineVerify', name:'今日网店核销', num:'', subLabel:'', subNum:'', type:'今日', icon:'' },
        { key: 'totalUnverifyPrincipal', name:'累计未核销', num:'', subLabel:'累计未核销', subNum:'', type:'累计', icon:'' },
        { key: 'monthStoreIncome', name:'本月门店收入（现金）', num:'', subLabel:'', subNum:'', type:'本月', icon:'' },
        { key: 'monthRechargeGift', name:'本月充值赠送', num:'', subLabel:'', subNum:'', type:'本月', icon:'' },
        { key: 'monthStoreVerify', name:'本月门店核销', num:'', subLabel:'', subNum:'', type:'本月', icon:'' },
        { key: 'monthOnlineVerify', name:'本月网店核销', num:'', subLabel:'', subNum:'', type:'本月', icon:'' },
      ],
      myAuditNumber:'',
      myAuditNumber2:'',
      myAuditNumber3:'',
      myApproved:'',
      showFlag:true,
      newDay,
      nowDay2,
      current:newDay,
      MyAuditDialogShow:false,
      isPlatformSide:false,
      chartInstances: {},
      projectRankingCountRangeType: 'month',
      projectRankingAmountRangeType: 'month',
      customerSourceRangeType: 'today',
      ticketShareRangeType: 'today',
      customerSourceChartData: [],
      hotProjectCountChartData: [],
      hotProjectAmountChartData: [],
      ticketShareChartData: [],
      periodFlowChartData: []
    }
  },
    created () {
        this.initHomeMode()
        // for (let item of JSON.parse(localStorage.userButtonList).userButtonList) {
        //     if (item.menu_name == "审批待办列表") {
        //         this.showFlag = true
        //     }
        // }
    },
  mounted () {
    if (!this.isPlatformSide) {
      this.getIncomeAmount()
      Promise.all([
        this.getProjectRankingCount(),
        this.getProjectRankingAmount(),
        this.getCustomerSource(),
        this.getTicketTypeShare(),
        this.getPeriodFlow()
      ]).finally(() => {
        this.$nextTick(() => {
          this.initDashboardCharts()
        })
      })
      window.addEventListener('resize', this.handleChartResize)
    }
    // this.refreshMyPending()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleChartResize)
    this.disposeDashboardCharts()
  },
  methods: {
    initHomeMode() {
      try {
        const personal = JSON.parse(localStorage.personal || '{}')
        const loginTissueId = String(localStorage.loginTissueId || personal.loginTissueId || '')
        const tissueList = Array.isArray(personal.tissueList) ? personal.tissueList : []
        const currentTissue = tissueList.find(item => String(item.id) === loginTissueId)
        const isPlatform = currentTissue && currentTissue.isPlatform !== undefined
          ? currentTissue.isPlatform
          : personal.isPlatform
        this.isPlatformSide = Number(isPlatform) === 1 || isPlatform === true
      } catch (e) {
        this.isPlatformSide = false
      }
    },
    formatDateTime(date) {
      const year = date.getFullYear()
      const month = this.zeroPadding(date.getMonth() + 1, 2)
      const day = this.zeroPadding(date.getDate(), 2)
      const hour = this.zeroPadding(date.getHours(), 2)
      const minute = this.zeroPadding(date.getMinutes(), 2)
      const second = this.zeroPadding(date.getSeconds(), 2)
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    },
    getDayRangeByOffset(dayOffset) {
      const baseDate = new Date()
      baseDate.setDate(baseDate.getDate() + dayOffset)
      const startDateObj = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 0, 0, 0, 0)
      const endDateObj = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 23, 59, 59, 999)
      const startDate = this.formatDateTime(startDateObj)
      const endDate = this.formatDateTime(endDateObj)
      return { startDate, endDate }
    },
    buildPeriodFlowTimeSlots () {
      const slots = []
      for (let hour = 8; hour <= 21; hour++) {
        const hh = this.zeroPadding(hour, 2)
        slots.push(hh + ':00')
      }
      return slots
    },
    extractHourFromPeriodFlowTime (timeText) {
      const text = String(timeText || '').trim()
      if (!text) return null
      const match = text.match(/^(\d{1,2})(?::\d{2})?/)
      if (!match) return null
      const hour = Number(match[1])
      return Number.isNaN(hour) ? null : hour
    },
    getCurrentMonthRange() {
      const now = new Date()
      const startDateObj = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0)
      const endDateObj = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999)
      return {
        startDate: this.formatDateTime(startDateObj),
        endDate: this.formatDateTime(endDateObj)
      }
    },
    getAmountFromResponse(data) {
      if (typeof data === 'number' || typeof data === 'string') {
        const value = Number(data)
        return Number.isNaN(value) ? '' : value
      }
      if (data && typeof data === 'object') {
        const candidates = [
          data.totalAmount,
          data.amount,
          data.total,
          data.totalPrincipalAmount,
          data.principalAmount,
          data.unsettledPrincipalAmount
        ]
        let raw
        for (let i = 0; i < candidates.length; i++) {
          const v = candidates[i]
          if (v !== undefined && v !== null) {
            raw = v
            break
          }
        }
        if (raw === undefined || raw === null || raw === '') return ''
        const value = Number(raw)
        return Number.isNaN(value) ? '' : value
      }
      return ''
    },
    getGiftAmountFromResponse(data) {
      if (data && typeof data === 'object') {
        const candidates = [
          data.totalGiftAmount,
          data.giftAmount,
          data.unsettledGiftAmount
        ]
        let raw
        for (let i = 0; i < candidates.length; i++) {
          const v = candidates[i]
          if (v !== undefined && v !== null) {
            raw = v
            break
          }
        }
        if (raw === undefined || raw === null || raw === '') return ''
        const value = Number(raw)
        return Number.isNaN(value) ? '' : value
      }
      return ''
    },
    displayStatValue(value) {
      if (value === undefined || value === null || value === '') return '--'
      return value
    },
    getCustomerSource (rangeType) {
      const type = rangeType || this.customerSourceRangeType || 'today'
      this.customerSourceRangeType = type
      const range = type === 'month'
        ? this.getCurrentMonthRange()
        : this.getDayRangeByOffset(0)
      const params = {
        startDate: range.startDate,
        endDate: range.endDate
      }
      return this.$api.report.customerSource(params).then(res => {
        if (!res || res.code !== 0) {
          this.customerSourceChartData = []
          return
        }
        const list = Array.isArray(res.data)
          ? res.data
          : ((res.data && Array.isArray(res.data.list)) ? res.data.list : [])
        this.customerSourceChartData = list.map(item => {
          const name = item && item.sourceName ? String(item.sourceName).trim() : ''
          const value = Number(item && item.number)
          return {
            name,
            value: Number.isNaN(value) ? 0 : value
          }
        }).filter(item => item.name && item.value > 0)
      }).catch(() => {
        this.customerSourceChartData = []
      })
    },
    switchCustomerSourceRange (rangeType) {
      if (this.customerSourceRangeType === rangeType) return
      this.getCustomerSource(rangeType).finally(() => {
        this.$nextTick(() => {
          this.renderCustomerSourceChart()
        })
      })
    },
    buildProjectRankingParams (rangeType) {
      const type = rangeType || 'month'
      const range = type === 'today'
        ? this.getDayRangeByOffset(0)
        : (type === 'month' ? this.getCurrentMonthRange() : null)
      return range
        ? {
          startDate: range.startDate,
          endDate: range.endDate
        }
        : {}
    },
    mapProjectRankingTop10 (res, valueKey) {
      if (!res || res.code !== 0) return []
      const list = Array.isArray(res.data)
        ? res.data
        : ((res.data && Array.isArray(res.data.list)) ? res.data.list : [])
      const mapped = list.map(item => {
        const name = item && item.productName ? String(item.productName).trim() : ''
        const rawValue = item && item[valueKey] !== undefined ? item[valueKey] : item && item.number
        const value = Number(rawValue)
        return {
          name,
          value: Number.isNaN(value) ? 0 : value
        }
      }).filter(item => item.name && item.value > 0)
      mapped.sort((a, b) => b.value - a.value)
      return mapped.slice(0, 10)
    },
    getProjectRankingCount (rangeType) {
      const type = rangeType || this.projectRankingCountRangeType || 'month'
      this.projectRankingCountRangeType = type
      const params = this.buildProjectRankingParams(type)
      return this.$api.report.projectRanking(params).then(res => {
        if (!res || res.code !== 0) {
          this.hotProjectCountChartData = []
          this.$message({
            message: (res && res.msg) || '热门项目TOP10（人数）获取失败',
            type: 'error'
          })
          return
        }
        this.hotProjectCountChartData = this.mapProjectRankingTop10(res, 'number')
      }).catch(() => {
        this.hotProjectCountChartData = []
        this.$message({
          message: '热门项目TOP10（人数）获取失败',
          type: 'error'
        })
      })
    },
    getProjectRankingAmount (rangeType) {
      const type = rangeType || this.projectRankingAmountRangeType || 'month'
      this.projectRankingAmountRangeType = type
      const params = this.buildProjectRankingParams(type)
      return this.$api.report.projectRankingAmount(params).then(res => {
        if (!res || res.code !== 0) {
          this.hotProjectAmountChartData = []
          this.$message({
            message: (res && res.msg) || '热门项目TOP10（金额）获取失败',
            type: 'error'
          })
          return
        }
        this.hotProjectAmountChartData = this.mapProjectRankingTop10(res, 'amount')
      }).catch(() => {
        this.hotProjectAmountChartData = []
        this.$message({
          message: '热门项目TOP10（金额）获取失败',
          type: 'error'
        })
      })
    },
    switchProjectRankingCountRange (rangeType) {
      if (this.projectRankingCountRangeType === rangeType) return
      this.getProjectRankingCount(rangeType).finally(() => {
        this.$nextTick(() => {
          this.renderHotProjectCountChart()
        })
      })
    },
    switchProjectRankingAmountRange (rangeType) {
      if (this.projectRankingAmountRangeType === rangeType) return
      this.getProjectRankingAmount(rangeType).finally(() => {
        this.$nextTick(() => {
          this.renderHotProjectAmountChart()
        })
      })
    },
    getTicketTypeShare (rangeType) {
      const type = rangeType || this.ticketShareRangeType || 'today'
      this.ticketShareRangeType = type
      const range = type === 'month'
        ? this.getCurrentMonthRange()
        : this.getDayRangeByOffset(0)
      const params = {
        startDate: range.startDate,
        endDate: range.endDate
      }
      const typeNameMap = {
        1: '单次项目票',
        2: '计时票',
        3: '计次套票',
        4: 'OTA抖音票',
        5: '充值卡'
      }
      return this.$api.report.ticketTypeShare(params).then(res => {
        if (!res || res.code !== 0) {
          this.ticketShareChartData = []
          return
        }
        const list = Array.isArray(res.data)
          ? res.data
          : ((res.data && Array.isArray(res.data.list)) ? res.data.list : [])
        this.ticketShareChartData = list.map(item => {
          const productType = Number(item && item.productType)
          const value = Number(item && item.number)
          return {
            name: typeNameMap[productType] || '',
            value: Number.isNaN(value) ? 0 : value
          }
        }).filter(item => item.name && item.value > 0)
      }).catch(() => {
        this.ticketShareChartData = []
      })
    },
    switchTicketShareRange (rangeType) {
      if (this.ticketShareRangeType === rangeType) return
      this.getTicketTypeShare(rangeType).finally(() => {
        this.$nextTick(() => {
          this.renderTicketShareChart()
        })
      })
    },
    getPeriodFlow () {
      const range = this.getDayRangeByOffset(0)
      const params = {
        startDate: range.startDate,
        endDate: range.endDate
      }
      return this.$api.report.periodFlow(params).then(res => {
        if (!res || res.code !== 0) {
          const slots = this.buildPeriodFlowTimeSlots()
          this.periodFlowChartData = slots.map(slot => ({
            time: slot,
            todayNumber: 0,
            yesterdayNumber: 0
          }))
          return
        }
        const list = Array.isArray(res.data)
          ? res.data
          : ((res.data && Array.isArray(res.data.list)) ? res.data.list : [])
        const flowByHour = {}
        list.forEach(item => {
          const time = item && item.time ? String(item.time).trim() : ''
          const hour = this.extractHourFromPeriodFlowTime(time)
          if (hour === null || hour < 8 || hour > 21) return
          const todayNumber = Number(item && item.todayNumber)
          const yesterdayNumber = Number(item && item.yesterdayNumber)
          flowByHour[hour] = {
            todayNumber: Number.isNaN(todayNumber) ? 0 : todayNumber,
            yesterdayNumber: Number.isNaN(yesterdayNumber) ? 0 : yesterdayNumber
          }
        })
        const slots = this.buildPeriodFlowTimeSlots()
        this.periodFlowChartData = slots.map(slot => {
          const hour = Number(slot.split(':')[0])
          const flow = flowByHour[hour] || { todayNumber: 0, yesterdayNumber: 0 }
          return {
            time: slot,
            todayNumber: flow.todayNumber,
            yesterdayNumber: flow.yesterdayNumber
          }
        })
      }).catch(() => {
        const slots = this.buildPeriodFlowTimeSlots()
        this.periodFlowChartData = slots.map(slot => ({
          time: slot,
          todayNumber: 0,
          yesterdayNumber: 0
        }))
      })
    },
    getIncomeAmount() {
      const todayRange = this.getDayRangeByOffset(0)
      const monthRange = this.getCurrentMonthRange()
      const buildTotalAmountForm = (range) => ({
        startDate: range && range.startDate ? range.startDate : undefined,
        endDate: range && range.endDate ? range.endDate : undefined,
      })
      Promise.all([
        this.$api.report.getCustomerByTime({
          startDate: todayRange.startDate,
          endDate: todayRange.endDate
        }),
        this.$api.report.getStoreIncome({
          startDate: todayRange.startDate,
          endDate: todayRange.endDate
        }),
        this.$api.report.getStoreIncome({
          startDate: monthRange.startDate,
          endDate: monthRange.endDate
        }),
        // 门店核销：今日/本月仅时间不同
        this.$api.report.storeWriteOff(buildTotalAmountForm(todayRange)),
        this.$api.report.storeWriteOff(buildTotalAmountForm(monthRange)),
        // 累计未核销金额：入参与后端 GetTotalAmountForm 对齐（可为空表示不过滤）
        this.$api.report.unsettledAmount(buildTotalAmountForm())
      ]).then(([todayCustomerRes, todayStoreIncomeRes, monthStoreIncomeRes, todayStoreWriteOffRes, monthStoreWriteOffRes, unsettledRes]) => {
        const customerItem = this.numberList.find(item => item.key === 'todayCustomer')
        if (customerItem) {
          customerItem.num = todayCustomerRes && todayCustomerRes.code === 0 ? this.getAmountFromResponse(todayCustomerRes.data) : ''
        }
        const todayStoreItem = this.numberList.find(item => item.key === 'todayStoreIncome')
        if (todayStoreItem) {
          todayStoreItem.num = todayStoreIncomeRes && todayStoreIncomeRes.code === 0 ? this.getAmountFromResponse(todayStoreIncomeRes.data) : ''
        }
        const todayRechargeGiftItem = this.numberList.find(item => item.key === 'todayRechargeGift')
        if (todayRechargeGiftItem) {
          todayRechargeGiftItem.num = todayStoreIncomeRes && todayStoreIncomeRes.code === 0 ? this.getGiftAmountFromResponse(todayStoreIncomeRes.data) : ''
        }
        const monthStoreItem = this.numberList.find(item => item.key === 'monthStoreIncome')
        if (monthStoreItem) {
          monthStoreItem.num = monthStoreIncomeRes && monthStoreIncomeRes.code === 0 ? this.getAmountFromResponse(monthStoreIncomeRes.data) : ''
        }
        const monthRechargeGiftItem = this.numberList.find(item => item.key === 'monthRechargeGift')
        if (monthRechargeGiftItem) {
          monthRechargeGiftItem.num = monthStoreIncomeRes && monthStoreIncomeRes.code === 0 ? this.getGiftAmountFromResponse(monthStoreIncomeRes.data) : ''
        }

        const todayStoreVerifyItem = this.numberList.find(item => item.key === 'todayStoreVerify')
        if (todayStoreVerifyItem) {
          todayStoreVerifyItem.num = todayStoreWriteOffRes && todayStoreWriteOffRes.code === 0 ? this.getAmountFromResponse(todayStoreWriteOffRes.data) : ''
        }
        const monthStoreVerifyItem = this.numberList.find(item => item.key === 'monthStoreVerify')
        if (monthStoreVerifyItem) {
          monthStoreVerifyItem.num = monthStoreWriteOffRes && monthStoreWriteOffRes.code === 0 ? this.getAmountFromResponse(monthStoreWriteOffRes.data) : ''
        }

        const totalUnverifyItem = this.numberList.find(item => item.key === 'totalUnverifyPrincipal')
        if (totalUnverifyItem) {
          if (unsettledRes && unsettledRes.code === 0) {
            totalUnverifyItem.num = this.getAmountFromResponse(unsettledRes.data)
            totalUnverifyItem.subNum = this.getGiftAmountFromResponse(unsettledRes.data)
          } else {
            totalUnverifyItem.num = ''
            totalUnverifyItem.subNum = ''
          }
        }
      }).catch(() => {
        const customerItem = this.numberList.find(item => item.key === 'todayCustomer')
        if (customerItem) {
          customerItem.num = ''
        }
        const todayStoreItem = this.numberList.find(item => item.key === 'todayStoreIncome')
        if (todayStoreItem) {
          todayStoreItem.num = ''
        }
        const todayRechargeGiftItem = this.numberList.find(item => item.key === 'todayRechargeGift')
        if (todayRechargeGiftItem) {
          todayRechargeGiftItem.num = ''
        }
        const monthStoreItem = this.numberList.find(item => item.key === 'monthStoreIncome')
        if (monthStoreItem) {
          monthStoreItem.num = ''
        }
        const monthRechargeGiftItem = this.numberList.find(item => item.key === 'monthRechargeGift')
        if (monthRechargeGiftItem) {
          monthRechargeGiftItem.num = ''
        }
        const todayStoreVerifyItem = this.numberList.find(item => item.key === 'todayStoreVerify')
        if (todayStoreVerifyItem) {
          todayStoreVerifyItem.num = ''
        }
        const monthStoreVerifyItem = this.numberList.find(item => item.key === 'monthStoreVerify')
        if (monthStoreVerifyItem) {
          monthStoreVerifyItem.num = ''
        }
        const totalUnverifyItem = this.numberList.find(item => item.key === 'totalUnverifyPrincipal')
        if (totalUnverifyItem) {
          totalUnverifyItem.num = ''
          totalUnverifyItem.subNum = ''
        }
      })
    },
    initDashboardCharts () {
      this.disposeDashboardCharts()
      this.renderCustomerSourceChart()
      this.renderHotProjectCountChart()
      this.renderHotProjectAmountChart()
      this.renderPeriodFlowChart()
      this.renderTicketShareChart()
    },
    renderCustomerSourceChart () {
      this.initSingleChart('customerSourceChart', {
        backgroundColor: 'transparent',
        color: ['#00d4ff', '#7c3aed', '#f093fb', '#4ecdc4'],
        tooltip: { trigger: 'item' },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'middle',
          textStyle: { color: '#6b7a99', fontSize: 12 }
        },
        series: [{
          type: 'pie',
          radius: ['45%', '70%'],
          center: ['35%', '50%'],
          avoidLabelOverlap: false,
          label: { show: false },
          itemStyle: {
            borderRadius: 8,
            borderColor: '#ffffff',
            borderWidth: 2
          },
          data: this.customerSourceChartData
        }]
      })
    },
    renderHotProjectCountChart () {
      this.initSingleChart('hotProjectChart', {
        backgroundColor: 'transparent',
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '3%', right: '12%', bottom: '6%', top: '6%', containLabel: true },
        xAxis: {
          type: 'value',
          axisLine: { show: false },
          splitLine: { lineStyle: { color: '#eef2f9' } },
          axisLabel: { color: '#6b7a99' }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: this.hotProjectCountChartData.map(item => item.name),
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#6b7a99' }
        },
        series: [{
          name: '热度',
          type: 'bar',
          barWidth: 18,
          data: this.hotProjectCountChartData.map(item => item.value),
          itemStyle: {
            borderRadius: [0, 8, 8, 0],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#7c3aed' },
              { offset: 1, color: '#00d4ff' }
            ])
          },
          label: { show: true, position: 'right', color: '#6b7a99' }
        }]
      })
    },
    renderHotProjectAmountChart () {
      this.initSingleChart('hotProjectChartCopy', {
        backgroundColor: 'transparent',
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '3%', right: '12%', bottom: '6%', top: '6%', containLabel: true },
        xAxis: {
          type: 'value',
          axisLine: { show: false },
          splitLine: { lineStyle: { color: '#eef2f9' } },
          axisLabel: { color: '#6b7a99' }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: this.hotProjectAmountChartData.map(item => item.name),
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#6b7a99' }
        },
        series: [{
          name: '热度',
          type: 'bar',
          barWidth: 18,
          data: this.hotProjectAmountChartData.map(item => item.value),
          itemStyle: {
            borderRadius: [0, 8, 8, 0],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#7c3aed' },
              { offset: 1, color: '#00d4ff' }
            ])
          },
          label: { show: true, position: 'right', color: '#6b7a99' }
        }]
      })
    },
    renderPeriodFlowChart () {
      this.initSingleChart('periodFlowChart', {
        backgroundColor: 'transparent',
        color: ['#00d4ff', '#7c3aed'],
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: {
          data: ['今日', '昨日'],
          top: '2%',
          textStyle: { color: '#6b7a99' }
        },
        grid: { left: '4%', right: '8%', top: '20%', bottom: '6%', containLabel: true },
        xAxis: {
          type: 'category',
          name: '时',
          nameLocation: 'end',
          nameGap: 18,
          nameTextStyle: { color: '#6b7a99' },
          data: this.periodFlowChartData.map(item => item.time),
          axisLine: { lineStyle: { color: '#e6ecf7' } },
          axisLabel: {
            color: '#6b7a99',
            interval: 0,
            formatter: (value) => {
              const match = String(value || '').match(/^0?(\d{1,2})/)
              return match ? match[1] : value
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          splitLine: { lineStyle: { color: '#eef2f9' } },
          axisLabel: { color: '#6b7a99' }
        },
        series: [{
          name: '今日',
          type: 'bar',
          barWidth: 8,
          barCategoryGap: '45%',
          barGap: '30%',
          data: this.periodFlowChartData.map(item => item.todayNumber),
          itemStyle: { color: '#00d4ff', borderRadius: [4, 4, 0, 0] }
        }, {
          name: '昨日',
          type: 'bar',
          barWidth: 8,
          data: this.periodFlowChartData.map(item => item.yesterdayNumber),
          itemStyle: { color: '#7c3aed', borderRadius: [4, 4, 0, 0] }
        }]
      })
    },
    renderTicketShareChart () {
      this.initSingleChart('ticketShareChart', {
        backgroundColor: 'transparent',
        color: ['#00d4ff', '#7c3aed', '#f093fb', '#4ecdc4'],
        tooltip: { trigger: 'item' },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'middle',
          textStyle: { color: '#6b7a99' }
        },
        series: [{
          type: 'pie',
          radius: '60%',
          center: ['35%', '50%'],
          itemStyle: {
            borderRadius: 8,
            borderColor: '#ffffff',
            borderWidth: 2
          },
          label: {
            color: '#6b7a99',
            formatter: '{d}%'
          },
          labelLine: { lineStyle: { color: '#a9b8d6' } },
          data: this.ticketShareChartData
        }]
      })
    },
    initSingleChart (refName, option) {
      const el = this.$refs[refName]
      if (!el) return
      const oldChart = this.chartInstances[refName]
      if (oldChart && oldChart.dispose) oldChart.dispose()
      const instance = echarts.init(el)
      instance.setOption(option, true)
      this.chartInstances[refName] = instance
    },
    handleChartResize () {
      const keys = Object.keys(this.chartInstances)
      for (let i = 0; i < keys.length; i++) {
        const chart = this.chartInstances[keys[i]]
        if (chart && chart.resize) chart.resize()
      }
    },
    disposeDashboardCharts () {
      const keys = Object.keys(this.chartInstances)
      for (let i = 0; i < keys.length; i++) {
        const chart = this.chartInstances[keys[i]]
        if (chart && chart.dispose) chart.dispose()
      }
      this.chartInstances = {}
    },
    flowchartPending(){
      this.$router.push('/index/Purchase/FlowchartPending')
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    getMyPending(){

    },
    refreshMyPending(){
      this.myPendingLoading = true
      this.$api.system.getActProcessInstancePage({status:1,pageNum:1,pageSize:0,approverId:localStorage.userId,roleId:localStorage.roleId}).then(res => {
          this.myPendingLoading = false
          if (res.code == 0) {
              this.myAuditNumber = Number(res.data.total)
          }else{
              this.$message({ message: res.msg, type: 'error' })
          }
      })
      // this.$api.system.getProcessStatistic({approverId:localStorage.userId,roleId:localStorage.roleId}).then(res => {
      //     if (res.code == 0) {
      //         for(let iuy of res.data){
      //           iuy.processDx = iuy.processId.replace(/_/g, '').toUpperCase()
      //         }
      //         this.numberList = res.data
      //     }else{
      //         this.$message({ message: res.msg, type: 'error' })
      //     }
      // })
      // this.$api.system.getActProcessInstancePage({status:1,pageNum:1,pageSize:0,approverId:localStorage.userId,roleId:localStorage.roleId,processId:'HTADDSP'}).then(res => {
      //     if (res.code == 0) {
      //         this.myAuditNumber2 = Number(res.data.total)
      //     }else{
      //         this.$message({ message: res.msg, type: 'error' })
      //     }
      // })
      // this.$api.system.getActProcessInstancePage({status:1,pageNum:1,pageSize:0,approverId:localStorage.userId,roleId:localStorage.roleId,processId:'GYSADDSP'}).then(res => {
      //     if (res.code == 0) {
      //         this.myAuditNumber3 = Number(res.data.total)
      //     }else{
      //         this.$message({ message: res.msg, type: 'error' })
      //     }
      // })
      // this.$api.system.getDonePage({pageNum:1,pageSize:0,pageBeginDate:this.nowDay2,approverId:localStorage.userId,roleId:localStorage.roleId}).then(res => {
      //     if (res.code == 0) {
      //         this.myApproved = Number(res.data.total)
      //     }else{
      //         this.$message({ message: res.msg, type: 'error' })
      //     }
      // })
    },
    myAuditClick(processDx,item){
      this.MyAuditDialogShow = true
      let type = '我的待办审核'
      if(processDx){
        type = item.name
      }
      this.$nextTick(()=>{
        this.$refs.MyAuditDialog.dialogShow(type,processDx)
      })
    },
    myApprovedClick(){
      this.$router.push('/index/Purchase/FlowchartAlready')
    },
  }
}
</script>
<style lang="stylus" scoped>
/* 首页：深色背景 + 数据看板布局 */
$accent = #409eff

.home_Index
  position relative
  box-sizing border-box
  min-height 100%
  height 100%
  overflow-y auto
  overflow-x hidden
  padding 18px 16px 24px
  text-align left
  background-color #f5f7fb
  background-image radial-gradient(circle at 0% 0%, rgba(64, 158, 255, 0.12), transparent 30%), radial-gradient(circle at 100% 20%, rgba(126, 90, 255, 0.1), transparent 24%)
  transform translateZ(0)
  backface-visibility hidden

.home-stats-grid
  position relative
  z-index 1
  display grid
  // 首页统计卡片：固定两排，一排 5 个（宽屏）
  grid-template-columns repeat(5, minmax(0, 1fr))
  gap 12px
  align-items stretch

@media (max-width: 1500px)
  .home-stats-grid
    grid-template-columns repeat(4, minmax(0, 1fr))

@media (max-width: 1100px)
  .home-stats-grid
    grid-template-columns repeat(3, minmax(0, 1fr))

@media (max-width: 860px)
  .home-stats-grid
    grid-template-columns repeat(2, minmax(0, 1fr))

@media (max-width: 560px)
  .home-stats-grid
    grid-template-columns 1fr

.content_item
  position relative
  height 100%
  min-height 122px
  padding 9px 10px 7px
  margin-top 2px
  background #ffffff
  border 1px solid #e6ebf4
  border-radius 14px
  box-shadow 0 5px 16px rgba(41, 73, 128, 0.08)
  overflow hidden
  transition transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease
  &:hover
    transform translateY(-3px)
    border-color #c8d8f6
    box-shadow 0 10px 24px rgba(37, 76, 139, 0.14)

.content_item::before
  content ''
  position absolute
  left 10px
  right 10px
  top 0
  height 4px
  border-radius 0 0 10px 10px

.content_item--0::before
  background linear-gradient(90deg, #409eff, #66b1ff)
.content_item--1::before
  background linear-gradient(90deg, #67c23a, #85ce61)
.content_item--2::before
  background linear-gradient(90deg, #e6a23c, #ebb563)
.content_item--3::before
  background linear-gradient(90deg, #f56c6c, #f78989)

.bold
  font-weight 700
.container_flex
  display flex
  justify-content space-between
  align-items center
  font-size 12px
.left
  text-align left
.right
  text-align right
.item-name
  color #2b3e63
  font-size 15px
  font-weight 800
  line-height 1.15
.item-num
  font-size 18px
  font-weight 700
  color #1d2f56
  padding 4px 0 2px
  letter-spacing 0.02em

.item-num-wrap
  display flex
  flex-direction column
  align-items flex-start
.item-divider
  border none
  height 1px
  margin 6px 0 0
  background #edf2fa
.item-foot
  min-height 16px

.top-hint
  margin 6px 0 2px
  color #b5bcc8
  font-size 11px
  line-height 1.1

.sub-num
  margin 0
  color #1d2f56
  font-size 18px
  font-weight 700
  line-height 1.1
.ri_label
  color #fff
  padding 3px 8px
  background linear-gradient(135deg, #3d9dff, #5d63ff)
  border-radius 8px
  font-size 10px
  font-weight 600
.yesterday
  color #909399
  font-size 11px
  i
    margin-left 4px
    color $accent

.dashboard-grid
  margin-top 30px
  display grid
  grid-template-columns repeat(12, minmax(0, 1fr))
  gap 16px

.dashboard-card
  grid-column span 4
  min-height 228px
  padding 10px 12px 8px
  border-radius 16px
  border 1px solid #e6ecf7
  background #ffffff
  box-shadow 0 8px 18px rgba(37, 76, 139, 0.08)

.dashboard-card--wide
  grid-column span 8

.dashboard-card--half
  grid-column span 6

.dashboard-card--full
  grid-column span 12

.card-header
  display flex
  align-items center
  justify-content space-between
  margin-bottom 8px

.card-title
  color #1f3158
  font-size 14px
  font-weight 600

.card-tabs
  display inline-flex
  align-items center
  gap 4px
  padding 4px
  border-radius 8px
  background #edf2fb

.card-tab
  padding 4px 10px
  border-radius 6px
  color #66789b
  font-size 11px
  line-height 1

.card-tab--active
  color #fff
  background linear-gradient(135deg, #00d4ff, #7c3aed)

.chart-box
  width 100%
  height 176px

.chart-box--ranking
  height 320px

@media (max-width: 1300px)
  .dashboard-card
    grid-column span 6
  .dashboard-card--wide
    grid-column span 12
  .dashboard-card--half
    grid-column span 12
  .dashboard-card--full
    grid-column span 12

@media (max-width: 980px)
  .content_item
    min-height 114px
  .item-num
    font-size 16px

@media (max-width: 780px)
  .dashboard-grid
    grid-template-columns 1fr
  .dashboard-card
    grid-column span 1
  .dashboard-card--wide
    grid-column span 1
</style>



// WEBPACK FOOTER //
// src/views/defaultPage/defaultPage.vue